import { useRef, useState } from 'react';

import { useOptimisticState } from './useOptimisticState';

export function useEditableTagList(opts: {
	serverValue: string[];
	onSave: (values: string[]) => void;
}) {
	const [displayTags, setOptimistic] = useOptimisticState(opts.serverValue);

	const [isEditing, setIsEditing] = useState(false);
	const [draftTags, setDraftTags] = useState<string[]>([]);
	const [newValue, setNewValue] = useState('');
	const draftRef = useRef<string[]>([]);

	const onEdit = () => {
		draftRef.current = [...displayTags];
		setDraftTags([...displayTags]);
		setNewValue('');
		setIsEditing(true);
	};

	const onSave = () => {
		if (newValue.trim()) {
			const val = newValue.trim();
			if (!draftRef.current.includes(val)) {
				draftRef.current = [...draftRef.current, val];
			}
		}
		setOptimistic(draftRef.current);
		opts.onSave(draftRef.current);
		setIsEditing(false);
	};

	const onCancel = () => setIsEditing(false);

	const onUpdateTag = (index: number, value: string) => {
		draftRef.current[index] = value;
		setDraftTags([...draftRef.current]);
	};

	const onRemoveTag = (index: number) => {
		draftRef.current = draftRef.current.filter((_, i) => i !== index);
		setDraftTags([...draftRef.current]);
	};

	const onAddTag = () => {
		if (newValue.trim()) {
			const val = newValue.trim();
			if (!draftRef.current.includes(val)) {
				draftRef.current = [...draftRef.current, val];
				setDraftTags([...draftRef.current]);
			}
			setNewValue('');
		}
	};

	return {
		displayTags,
		isEditing,
		draftTags,
		newValue,
		onEdit,
		onSave,
		onCancel,
		onUpdateTag,
		onRemoveTag,
		onAddTag,
		setNewValue,
	};
}
